import { useTranslation } from 'react-i18next'

const SalesPersonStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="sales-person-start-title"
      {...props}
    >
      <title id="sales-person-start-title">{t('antagonists:salesPerson:components:start')}</title>
      <path
        d="M1613.47 1006.51c10.64-.28 16.54-6.62 18.02-9.19 1.47-2.57.31-24.33-.73-34.57-.95-9.4-2.21-30.83-8.41-30.7-4.9.1-25.78.53-26.15 10.83s.42 35.74.05 42.73c-.37 6.99-.38 13.13 3.61 15.76 3.65 2.4 10.12 5.24 13.6 5.15ZM1507.3 1007.87c5.39.37 14.71-2.57 17.65-5.15s4.61-9.51 3.31-18.38c-2.1-14.26-1.88-31.55-1.57-37.96.23-4.77-3.43-19.42-14.61-19.4-17.24.03-21.74 15.42-21.16 21.82.76 8.35 1.67 28.18.57 36.64s-1.4 16.11 2.69 18.32c4.12 2.22 8.83 3.82 13.12 4.11Z"
        style={{
          fill: '#bd2e86',
        }}
      />
      <path
        d="M1475.95 626.84s.26 100.12 2.48 113.45-6.66 60.72-4.44 82.93c2.22 22.21 17.03 82.93 18.51 90.33 1.48 7.4-1.75 15.28.82 20.43s1.1 16.91 1.47 23.53-2.09 28.81 3.79 29.54c5.88.74 23.78.6 25.25-3.07s-1.84-16.54-.74-24.63-.74-10.66-1.47-16.91-2.57-12.87-3.68-19.49c-1.1-6.62-5.15-18.02-3.31-28.68s8.82-52.21 7.72-73.9-4.78-34.56-2.94-43.75c1.84-9.19 7.35-19.12 6.62-36.4s23.49-114.59 23.49-114.59l-73.59 1.21ZM1550.97 634.44s12.13 118.75 18.38 136.03c6.25 17.28 9.19 28.68 10.29 39.71 1.1 11.03 3.31 30.15 9.56 50.74 6.25 20.59 12.5 33.82 12.13 43.75-.37 9.93-1.84 17.34-2.67 22.47-.88 5.49.46 19.44.46 29.37s-1.84 19.85 1.1 22.06c2.94 2.21 21.78 2.47 24.72 1.74s3.32-14.96 2.95-25.25c-.37-10.29-4.51-13.99-4.14-19.5.37-5.51.37-11.03.37-23.53s7.39-76.93 5.15-101.11c-2.36-25.5-18.19-54.26-18.56-65.29-.37-11.03-3.27-105.52-3.27-105.52l-56.48-5.67Z"
        style={{
          fill: '#f2bfba',
        }}
      />
      <path
        d="M1643.68 539.88s-.25 43.81 4.2 54.15c4.45 10.34 16.34 30.29 17.39 36.01.54 2.96-5.83 20.27-6.7 21.49-1.6 2.23-15.63 15.38-15.63 15.38s-2.19-2.83-1.01-5.44c2.07-4.61 5.73-9.34 6.37-10.93.64-1.59 1.13-6.68.39-10.44-.74-3.77-2.46-9.97-4.69-9.02-2.23.96 1.77 9.64 2.42 12.77.65 3.13.48 8.1.48 8.1s-3.87 2.65-4.58 1.84c-1.44-1.62-3.71-3.94-5.35-9.52-1.64-5.57-2.49-7.81-4.82-12.21-2.33-4.4-5.61-31.53-4.76-37.86.73-5.5-10.91-49.56-10.91-49.56l27.21-4.77Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1541.9 206.89c-4-.07-11.94-4.69-23.62 4.12-21.37 16.12-22.26 67.19-24.12 89.02-2.03 23.94-4.24 122.98-4.24 122.98l93.91 1.38s13.68-99.66 9.54-129.09c-3.02-21.44-6.04-39.82-10.24-53.93-4.39-14.75-9.58-25.34-20.55-32.21-7.61-4.76-15.23-2.18-20.69-2.27Z"
        style={{
          fill: '#c1a172',
        }}
      />
      <path
        d="M1522.53 277.4s5.42 23.03 5.33 28.34c-.09 5.31.91 18.4-7.59 21.49-13.76 5-30.36 9.36-30.36 9.36l-19.42 7.86 4 41.72s132.74 12.54 131.99 12.73c-.75.19-12.49-59.23-12.49-59.23s-16.16-5.6-23.77-9.65c-6.94-3.7-2.76-14.54-2.08-24.07.88-12.27 3.51-19.37 3.51-19.37l-49.14-9.17Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1547 227.91c-6.92.58-9.77 11.02-15.9 19.08-7.55 9.94-9.58 9.54-13.26 15.46-7.05 11.34-.67 24.95-.67 24.95s13.31 24.5 26.57 25.79c13.27 1.29 16.47-1.42 23.06-7.82s9.77-14.07 11.33-19.54c1.34-4.68-6.15-28.86-10.41-35.09-5.68-8.3-16.21-23.22-20.72-22.84Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1581.4 281.42c-.78 1.94-4.04-.03-4.04-.03s-4.84-17.85-5.26-18.38c0 0 5.53-5.46 7.9-4.1 3.72 2.14 1 5.35 1.19 10.73 0 .2 1.61 8.29.21 11.77ZM1512.55 285.92c1.66 1.27 6.12-2.35 6.12-2.35s-1.01-18.49-.69-19.09c0 0-5.59-3.35-7.95-1.99-2.36 1.36-1.99 4.22-1.19 9.54.8 5.32 2.05 12.61 3.71 13.88Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1541.28 291.32c.32 1.51 6.12 2.28 10.65 2.23 4.53-.05 10.71-1.42 10.94-3.47.23-2.05-3.12-6.04-5.79-5.78-2.67.26-3.58.55-4.51.44-.93-.11-4.07-1.09-6.8-.27-2.73.82-5.1 3.95-4.49 6.85Z"
        style={{
          fill: '#e95b27',
        }}
      />
      <path
        d="m1539.14 252.54-1.81 4.25s-9.05-2.87-12.1-2.91c-3.05-.04-8.12 1.42-8.12 1.42l-.44-2.57s5.33-3.7 10.84-2.59c5.51 1.11 11.62 2.4 11.62 2.4ZM1554.81 251.49s9.55-5.62 12.88-5.28c3.07.32 6.01 2.35 6.01 2.35l-.5 1.77s-3.44-1.59-6.49-.39c-3.04 1.19-10.37 4.93-10.37 4.93l-1.54-3.38Z"
        style={{
          fill: '#c1a172',
        }}
      />
      <path
        d="m1522.66 260.42 14.02 2.05s.16-7.45-7.33-6.85c-4.73.38-6.69 4.8-6.69 4.8ZM1572.29 256.49l-13.27 2.9s-.27-5.81 6.72-6.83c4.45-.65 6.55 3.93 6.55 3.93Z"
        style={{
          fill: '#0095d8',
        }}
      />
      <path
        d="m1531.17 264.38-5.18-.1v-1.87l6.38-.21s-1.02 2.15-1.2 2.17Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1532.12 263.26-6.18-2.04.51-1.81 5.68 1.65-.01 2.2z"
      />
      <path
        d="M1530.97 261.01c-1.07 1.71-.67 3.64 1.05 4.62 1.72.98 3.61.54 4.67-.94 1.25-1.74.42-3.46-1.24-4.65-1.17-.84-3.37-.8-4.47.96ZM1565.82 261l5.13-.89-.23-1.87-6.35.78s1.28 2 1.46 1.99Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1564.93 259.92 5.64-2.74-.73-1.66-5.2 2.31.29 2.09z"
      />
      <path
        d="M1565.29 257.32c1.29 1.56 1.15 3.52-.43 4.72-1.57 1.2-3.13 1.06-4.37-.26-1.47-1.56-1.26-3.42.23-4.82 1.05-.99 3.24-1.25 4.56.36ZM1635.37 476.91c-.2-7.67-5.12-42.2-6.05-74.08-1.02-34.88-.23-58.04-20.41-60.84l-20.34 39.57s10.12 85.97 12.14 107.95c.68 7.43 17.7 71.63 17.7 71.63l28.79-2.54s-11.78-79.82-11.83-81.69Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1593.65 482.05c-.65-15.81 20.67-52.9 22.38-73.35 1.7-20.45 5.34-63.44-4.46-66-9.8-2.56-29.67-8.37-29.67-8.37s-8.46 2.94-36.54 1.65c-19.33-.89-35.46-6.82-35.46-6.82s-29.36 9.16-43.85 16.4c-14.49 7.24-4.98 27.48-1.14 45.38 3.84 17.9 22.75 73.24 22 87.81-2.01 39.06-21.78 44.6-24.42 100.89-2.27 48.51 3.02 92.36 12.19 169.61 0 0 35.26 4.53 70.86 3.25 35.46-1.28 69.15-11.17 69.15-11.17s8.97-120.16.98-160.35c-9.28-46.7-20.85-70.51-22.02-98.93Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1458.23 575.69c1.41-1.84-2.57-10.72-3.55-15.72-.82-4.22-7.08-22.07-7.55-26.26-.25-2.19-10.16-13.45-23.81-27.43l20.35-17.67c.51.74 8.02 14.89 12.85 20.35 8.95 10.1 11.59 19.77 14.65 26.21 3.06 6.44 20.41 26.78 21.42 33.03.34 2.1-18.2 19.51-21.3 21.08-3.39 1.71-14.36-4.81-16.12-6.42-2.6-2.38-8.9-9.99-8.9-9.99s2.95-1.98 6.13-1.29c3.3.71 4.45 5.89 5.82 4.11Z"
        style={{
          fill: '#eec796',
        }}
      />
      <path
        d="M1465.68 346.72c-11.14 4.29-28.38 33.05-48.48 59.73-16.68 22.14-26.08 38.4-30.47 49.31-4.39 10.91 2.25 21.32 20.84 40.55 15.12 15.64 24.16 26.6 24.16 26.6l24.09-15.02s-27.07-41.68-28.24-45.1c-1.17-3.41 11.78-15.32 21.06-26.16 17.34-20.24 44.31-41.18 44.31-47.84 0-13.13-27.27-42.08-27.27-42.08Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1494.16 300.04s-7.2 40.28-5.32 70.88c1.87 30.6 6.87 56.83 6.87 56.83s26.01 3.41 39.01-16.11c13-19.52-3.89-60.88-6.39-78.37-2.5-17.48-1.34-28.22-1.34-28.22l-32.82-5Z"
        style={{
          fill: '#c1a172',
        }}
      />
    </svg>
  )
}

export default SalesPersonStart